import { Dialog as StandaloneDialog } from '@/components/Dialog';
import { ArticlePaywallForm as StandaloneArticlePaywallForm } from '@/components/standalone/ArticlePaywall/Form';
import { ArticlePaywallSuccessfulPayment } from '@/components/standalone/ArticlePaywall/SuccessfulPayment';
import { ArticlePaywallTheme } from '@/components/standalone/ArticlePaywall/theme';
import { FrisbiiPayment as StandaloneFrisbiiPayment } from '@/components/standalone/FrisbiiPayment';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: ArticlePaywallTheme });

const Base = $({ as: 'section', slot: 'base' });
const Description = $({ as: 'p', slot: 'description' });
const Headline = $({ as: 'h2', slot: 'headline' });
const Logo = $({ as: 'div', slot: 'logo' });
const FeaturesList = $({ as: 'ul', slot: 'featuresList' });
const Feature = $({ as: 'li', slot: 'feature' });
const Dialog = GenericSlot({ as: StandaloneDialog, theme: ArticlePaywallTheme.Dialog });
const Form = GenericSlot({ as: StandaloneArticlePaywallForm, theme: ArticlePaywallTheme.Form });
const FrisbiiPayment = GenericSlot({ as: StandaloneFrisbiiPayment, theme: ArticlePaywallTheme.FrisbiiPayment });
const SuccessfulPayment = GenericSlot({
  as: ArticlePaywallSuccessfulPayment,
  theme: ArticlePaywallTheme.SuccessfulPayment,
});
const Error = $({ as: 'div', slot: 'error' });

export const ArticlePaywall = Object.assign(Base, {
  Description,
  Headline,
  Logo,
  FeaturesList,
  Feature,
  Dialog,
  Form,
  FrisbiiPayment,
  SuccessfulPayment,
  Error,
});
